<template>
  <a-layout>
    <vxe-table
      border
      stripe
      round
      show-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      keep-source
      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      :checkbox-config="{trigger: 'row'}"
      style="margin-top: 2px">
      <vxe-column :type="selectType" fixed="left" width="50"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="200"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="200"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="lot.no" title="business.label.lot" width="150"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
      <vxe-column field="command.allocateQuantity" title="business.label.allocateQuantity" width="150"/>
      <vxe-column v-if="!stereoscopic" field="allocateLocation.no" title="business.label.allocateLocation" width="200px"/>
      <vxe-column v-if="!stereoscopic" :edit-render="{autofocus: '.vxe-input--inner'}" field="command.putawayQuantity" fixed="right" title="business.label.putawayQuantity" width="150">
        <template #edit="{ row }">
          <vxe-input v-model="row.command.putawayQuantity" :max="row.command.allocateQuantity" :min="1" align="center" placeholder="" type="number"/>
        </template>
      </vxe-column>
      <vxe-column v-if="!stereoscopic" :edit-render="{}" field="storageRoom.name" fixed="right" title="business.label.targetStorageRoom" width="200px">
        <template #edit="{ row }">
          <vxe-input v-model="row.storageRoom.name" align="center" placeholder="点击选择" readonly type="search" @click="openStorageRoomModal(row)" @search-click="openStorageRoomModal(row)"/>
        </template>
      </vxe-column>
      <vxe-column v-if="!stereoscopic" :edit-render="{}" field="putawayLocation.no" fixed="right" title="business.label.putawayLocation" width="200px">
        <template #edit="{ row }">
          <vxe-input v-model="row.putawayLocation.no" align="center" placeholder="点击选择" readonly type="search" @click="openLocationModal(row)" @search-click="openLocationModal(row)"/>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <StorageRoomModal ref="storageRoomModal" @change="onStorageRoomChange"/>
    <LocationModal ref="locationModal" @change="onLocationChange"/>
  </a-layout>
</template>
<script>
import { findAll, post } from '@/api/Api'
import ColumnNumberEditor from '@/components/Editor/ColumnNumberEditor.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import PageUtil from '@/components/Pagination/PageUtil.vue'
import Api from '@/api'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Location } from '@/api/dto/common/Location'

export default {
    name: 'ShelfTask',
    components: {PageUtil, StorageRoomModal, LocationModal, ColumnNumberEditor},
    data() {
      return {
        data: [],
        commandStatusData: [],
        loading: false,
        size: 15,
        page: 1,
        contentSize: 0,
        query: {
          inspected: true,
          commandStatusRange: {start: 'GENERATED', end: 'PUTAWAY_OBTAINED'}
        },
        numberEditor: 'numberEditor'
      }
    },
    props: {
      args: {
        type: Object,
        default: null
      },
      selectType: {
        type: String,
        default: 'checkbox'
      },
      stereoscopic: {
        type: Boolean,
        default: false
      },
      scrollY: {
        type: [Number, Boolean],
        default: false
      }
    },
    methods: {
      pageChange({currentPage, pageSize}) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData(args) {
        this.loading = true
        if (args !== null && args !== undefined) {
          Object.assign(this.query, args)
        }
        findAll('receiptCommandFactory', this.query, this.page, this.size).then(res => {
          if (res.success) {
            this.data = res.result
            this.contentSize = res.contentSize
          }
        }).finally(() => {
          this.loading = false
        })
      },
      search(args) {
        this.page = 1
        this.getData(args)
      },
      openStorageRoomModal(row) {
        if (!this.automatic) {
          let args = {physical: true}
          this.$refs.storageRoomModal.open(args, row)
        }
      },
      onStorageRoomChange(e, row) {
        if (e.length > 0) {
          row.storageRoom = Object.assign(new StorageRoom(), e[0])
        } else {
          row.storageRoom = new StorageRoom()
        }
        row.putawayLocation = new Location()
      },
      openLocationModal(row) {
        if (row.storageRoom === undefined || row.storageRoom === null || row.storageRoom.id === null) {
          this.$message.warning('请先选择目标库房')
        } else {
          let args = {available: true, locking: false, mechanicalLocking: false, 'storageRoom.id': row.storageRoom.id}
          this.$refs.locationModal.open(args, row)
        }
      },
      onLocationChange(e, row) {
        if (e.length > 0) {
          row.putawayLocation = Object.assign(new Location(), e[0])
        } else {
          row.putawayLocation = new Location()
        }
      },
      reset() {
        this.query = {
          inspected: true,
          commandStatusRange: {start: 'GENERATED', end: 'PUTAWAY_OBTAINED'}
        }
        this.data = []
      },
      putaway() {
        let selectRows
        if (this.selectType === 'radio') {
          selectRows = this.$refs.table.getRadioRecord() === null ? [] : [this.$refs.table.getRadioRecord()]
        } else {
          selectRows = this.$refs.table.getCheckboxRecords()
        }
        if (selectRows.length === 0) {
          return this.$message.warning('请选择需要上架的指令')
        }
        this.loading = true
        let args = []
        selectRows.forEach(item => {
          let arg = {id: item.command.id, putawayQuantity: item.command.putawayQuantity, putawayLocation: item.putawayLocation}
          args.push(arg)
        })
        post(Api.receivingReceiverCommandsPutaway, {}, args).then(res => {
          if (res.success) {
            this.$message.success('上架成功')
            this.getData()
          }
        }).finally(() => {
          this.loading = false
        })
      },
      review() {
        let selectRows
        if (this.selectType === 'radio') {
          selectRows = this.$refs.table.getRadioRecord() === null ? [] : [this.$refs.table.getRadioRecord()]
        } else {
          selectRows = this.$refs.table.getCheckboxRecords()
        }
        if (selectRows.length === 0) {
          return this.$message.warning('请选择复核的指令')
        }
        this.loading = true
        let args = {'container.no': selectRows[0].container.no, passed: true}
        post(Api.receivingReceiverReview, {}, args).then(res => {
          if (res.success) {
            this.$message.success('复核成功')
            this.getData()
          }
        }).finally(() => {
          this.loading = false
        })
      },
      reject() {
        let selectRows
        if (this.selectType === 'radio') {
          selectRows = this.$refs.table.getRadioRecord() === null ? [] : [this.$refs.table.getRadioRecord()]
        } else {
          selectRows = this.$refs.table.getCheckboxRecords()
        }
        if (selectRows.length === 0) {
          return this.$message.warning('请选择复核不通过的指令')
        }
        this.loading = true
        let args = {'container.no': selectRows[0].container.no, passed: false}
        post(Api.receivingReceiverReview, {}, args).then(res => {
          if (res.success) {
            this.$message.success('复核成功')
            this.getData()
          }
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>